import { render } from "./Step_3.vue?vue&type=template&id=bcb6010c"
import script from "./Step_3.vue?vue&type=script&lang=js"
export * from "./Step_3.vue?vue&type=script&lang=js"

import "./Step_3.vue?vue&type=style&index=0&id=bcb6010c&lang=scss"

import exportComponent from "/home/sc1nboq9356/staging-meiser/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__